import HoverCoordinates from '@intercom/embercom-composer/lib/editor/hover-coordinates';
import $ from 'jquery';
import { bind } from '@ember/runloop';
import Em from 'ember';
export default Em.Mixin.create({
  initHoverCoordinates() {
    this.set('hoverCoordinates', HoverCoordinates.create({
      editorDimensions: this.get('editorDimensions'),
      $editor: this.get('$editor'),
      hoverAreaPadding: this.get('hoverAreaPadding'),
      mouseX: 0,
      mouseY: 0
    }));
    this.setupHoverLoadListeners();
  },
  willDestroyHoverCoordinates: Em.on('willDestroyElement', function () {
    $('.embercom-composer img').off(`load.hover${this.get('elementId')}`);
    let hoverCoordinates = this.get('hoverCoordinates');
    if (hoverCoordinates) {
      hoverCoordinates.destroy();
      this.set('hoverCoordinates', null);
    }
  }),
  setupHoverLoadListeners() {
    $('.embercom-composer img').on(`load.hover${this.get('elementId')}`, bind(this, this.setHoverCoordinates));
  },
  setHoverCoordinates(mouseX, mouseY) {
    let hoverCoords = this.get('hoverCoordinates');
    if (hoverCoords && !this.get('disableHoveredBlockUpdates')) {
      hoverCoords.updateMouseCoordinates(mouseX, mouseY);
    }
  }
});